import { initial } from "lodash";

ClubProfileController.$inject = ['$scope', 'Club', 'CONST', 'Time', '_', 'alerts', '$rootScope', 'User', 'API'];

/* @ngInject */
function ClubProfileController($scope, Club, CONST, Time, _, alerts, $rootScope, User, API) {
    var vm = this;
    vm.title = 'ClubProfileController';

    vm.loading = {
        all: false,
        basic: false,
        looks: false,
        attrs: false
    };

    vm.sportclub_id = Club.id;
    vm.name = Club.name;
    vm.state = Club.state === 2;
    vm.has_beelup = "false";
   
    vm.country_code = CONST.countries[Club.zone.country_id] ?? "AR";
    

    vm.phone = Club.phone;
    vm.location = Club.location;
    vm.permalink = Club.permalink;
    vm.has_payment_credentials = CONST.has_payment_credentials;

    beelupGetClubs();

    vm.coordinates_edit = false;
    vm.location_lat = Club.location_lat;
    vm.location_long = Club.location_long;
    vm.zone_map_name = Club.zone.map_name;
    // Only show for argentina and perú
    vm.isCountryRestricted = (Club.zone.country_id !== 1 && (Club.zone.country_id !== 4 || Club.id !== 785)) ? true : false;

    vm.attributes = _.clone(CONST.attributes.club);
    _.each(vm.attributes, function(attr) {
        attr.checked = _.includes(Club.attributes, attr.id);
    });

    vm.neighbourhoods = Club.zone.neighbourhoods;
    vm.neighbourhood_edit = vm.neighbourhoods.length > 0;
    vm.neighbourhood_id = Club.neighbourhood_id;

    vm.logo = CONST.STATIC.$logo(Club.logo);
    vm.background = CONST.STATIC.$bg(Club.background);

    vm.checkCourtConfigurations = function() {
        vm.loadingConnectButton = true;
        Club.API.getList('courts', { full: true })
            .then(function(courts) {
                vm.has_ac = courts.some(court => court.capture === false);

                vm.showConnectButton = (!vm.has_payment_credentials || !vm.has_ac) && !vm.isCountryRestricted;
            })
            .catch(alerts.errorHandler)
            .finally(function() {
                vm.loadingConnectButton = false;
            });
    };

    vm.checkCourtConfigurations();

    vm.save_basic = function() {
        alerts.code(null, null, User).then(save_basic);
    };
    vm.save_looks = function() {
        alerts.code(null, null, User).then(save_looks);
    };
    vm.save_attrs = function() {
        alerts.code(null, null, User).then(save_attrs);
    };

    vm.edit_logo = function() {
        $rootScope.cropper({
            title: 'Logo',
            src: vm.logo,
            API: Club.API.one('upload'),
            id: 'logo',
            ratio: 4 / 5,
        }).result.then(function(res) {
            if (!res) return;
            Club.logo = res.logo;
            vm.logo = CONST.STATIC.$logo(Club.logo);
        });
    };

    vm.edit_bg = function() {
        $rootScope.cropper({
            title: 'Fondo',
            src: Club.background ? vm.background : null,
            API: Club.API.one('upload'),
            id: 'background',
            ratio: 5 / 3,
            output: {
                width: 1000,
                format: 'jpeg'
            }
        }).result.then(function(res) {
            if (!res) return;
            Club.background = res.background;
            vm.background = CONST.STATIC.$bg(Club.background);
        });
    };

    function save_basic(code) {
        vm.loading.basic = true;
        var data = format_basic(vm);
        data.code = code;

        Club.API.customPUT(data, '').then(function(res) {
                Club.update(res, data);
                vm.name = Club.name;
                vm.state = Club.state === 2;
                vm.phone = Club.phone;
                vm.location = Club.location;
                vm.location_lat = Club.location_lat;
                vm.location_long = Club.location_long;
                vm.zone_map_name = Club.zone.map_name;
            })
            .catch(alerts.errorHandler)
            .finally(function() {
                vm.loading.basic = false;
            });
    }

    function save_attrs(code) {
        var data = {
            attributes: format_attrs(vm),
            code: code
        };

        vm.loading.attrs = true;
        Club.API.customPUT(data, '').then(function(res) {
                Club.update(res, data);
            })
            .catch(alerts.errorHandler)
            .finally(function() {
                vm.loading.attrs = false;
            });
    }

    function format_basic(vm) {
        var data = {
            name: vm.name,
            state: vm.state,
            location: vm.location,
            phone: vm.phone,
            neighbourhood_id: vm.neighbourhood_id
        };

        if (vm.coordinates_edit) {
            data.location_lat = vm.location_lat;
            data.location_long = vm.location_long;
        }

        return data;
    }

    function format_attrs(vm) {
        return _.map(_.filter(vm.attributes, function(attr) {
            return attr.checked;
        }), function(attr) {
            return attr.id;
        });
    }

    vm.beelupConnectionRequest = function(beelup) {
        vm.loading.basic = true;
        Club.API.customPOST({
            'beelup_complejo_id': vm.beelup_sportclubSELECT
        },'beelup/connect/club')
        .then(function(data) {
            stateBeelup(data);
        })
        .catch(alerts.errorHandler)
        .finally(function() {
            vm.loading.basic = false;
        });
        return;
    }


    vm.beelupRemoveClub = function (court) {
        alerts.confirm('Conexión Beelup',
            '¿Realmente desea cancelar la conexión de su Club con Beelup?')
            .then(beelupRemoveClubRequest.bind());
    };

    function beelupRemoveClubRequest() {
        vm.loading.basic = true;
        var beelupApi = API.service('/sportclubs/'+Club.id+'/beelup/disconnect/club');
        beelupApi.post({})
        .then(function(data) {
            if (data.original.status == 200) {
                beelupGetClubs();
            }
        })
        .catch(alerts.errorHandler)
        .finally(function() {
            vm.loading.basic = false;
        });
        return;
    }

    function beelupGetClubs() {
        vm.loading.basic = true;
        Club.API.customGET("beelup/get-beelup-clubs")
            .then((data) => {
                switch (data) {
                    case "pending":
                        stateBeelup("pending");
                        break;
                    case "true":
                        stateBeelup("true");
                        break;
                    default:
                        stateBeelup("false");
                        vm.beelup_sportclubs = data;
                        break;
                }
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading.basic = false;
            });
        return;
    }


    function stateBeelup(data) {
        vm.has_beelup = data;
    }


}

export default ClubProfileController;
